<template>
  <div class="projects-box">
    <menuBox :step="5"></menuBox>
    <div class="title-box">
      <div class="title">
        <p>ติดต่อเรา</p>
        <span>เราหวังว่าจะได้รับการติดต่อจากคุณและหารือเกี่ยวกับวิธีเพิ่มมูลค่าให้กับธุรกิจของคุณผ่านผลิตภัณฑ์โลหะคุณภาพสูง</span>
      </div>
    </div>
    <div class="find">
      <div class="left">
        <div class="bt">ทำงานกับเรา</div>
        <div class="address">ที่อยู่:39/43 หมู่ที่ 7 ตำบลบ้านสร้าง อำเภอบางปะอิน จ.พระนครศรีอยุธยา 13170</div>
        <div class="address">โทรศัพท์:949502179</div>
        <div class="address">จดหมาย:css@tssrenovation.com</div>
      </div>
      <div class="right">
        <div class="title">ติดต่อเราเพื่อเริ่มต้นการเดินทางของคุณสู่โซลูชันโลหะสั่งทำ</div>
        <div class="text">ความต้องการของคุณ ความสนใจของเรา ติดต่อเราเพื่อรับประสบการณ์การบริการลูกค้าที่ยอดเยี่ยม</div>
        <input type="text" placeholder="ชื่อ">
        <input type="text" placeholder="จดหมาย">
        <input type="text" placeholder="โทรศัพท์">
        <textarea placeholder="ข้อมูล"></textarea>
        <div class="btn" @click="submit">
          ส่งข้อความ
        </div>
      </div>
    </div>
    <footerBox></footerBox>
  </div>
</template>
<script>
import footerBox from "@/components/footer";
import menuBox from "@/components/menu";
export default {
  name: "projects",
  components: {
    menuBox,
    footerBox,
  },
  data() {
    return {
    };
  },
  mounted() { },
  methods: {
    submit() {
      alert('ความสำเร็จ!')
    }
  },
};
</script>
<style lang="less" scoped>
.projects-box {
  .title-box {
    background-image: url(../assets/contact.png);
    width: 100%;
    height: 420px;
    background-size: 100% 100%;
    overflow: hidden;
    padding: 240px 360px 0 360px;
    text-align: center;
    box-sizing: border-box;

    .title {
      float: right;
      width: 600px;
      text-align: right;

      p {
        margin-bottom: 20px;
        font-size: 56px;
        color: #FFFFFF;
        line-height: 67px;
      }

      span {
        font-size: 20px;
        color: #FFFFFF;
        line-height: 24px;
      }
    }
  }
}

.find {
  padding: 100px 360px;
  display: flex;
  justify-content: space-between;

  .left {
    margin-right: 74px;

    .bt {
      margin-bottom: 24px;
      font-size: 40px;
      color: #333333;
      line-height: 48px;
    }

    .address {
      font-size: 16px;
      color: #333333;
      line-height: 28px;
    }
  }

  .right {
    .title {
      margin-bottom: 24px;
      font-size: 40px;
      color: #333333;
      line-height: 48px;
    }

    .text {
      margin-bottom: 48px;
      font-size: 22px;
      color: #999999;
      line-height: 26px;
    }

    input {
      display: block;
      margin-bottom: 32px;
      padding: 12px;
      width: 744px;
      height: 48px;
      border: 1px solid #999999;
      box-sizing: border-box;
    }

    textarea {
      padding: 12px;
      width: 744px;
      height: 140px;
      border: 1px solid #999999;
      box-sizing: border-box;
    }

    .btn {
      margin-top: 44px;
      display: table;
      background: #F65331;
      font-size: 20px;
      color: #FFFFFF;
      padding: 12px 38px;
      box-sizing: border-box;
      cursor: pointer;
    }
  }
}
</style>
